import * as math from 'mathjs';

/** 加法 */
export function add(a,b) {
  return math.add(math.bignumber(a), math.bignumber(b));
}

/** 减法 */
export function subtract(a,b) {
  return math.subtract(math.bignumber(a), math.bignumber(b));
}

/** 乘法 */
export function multiply(a,b) {
  return math.multiply(math.bignumber(a), math.bignumber(b));
}

/** 除法 */
export function divide(a,b) {
  return math.divide(math.bignumber(a), math.bignumber(b));
}